module.exports = __webpack_public_path__ + "img/bf20b97.webp";